import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Link } from "react-router-dom";
import config from "config.json";

import "css/main.css";
import "css/style.css";

import Topnav from "components/Topnav";
import TopAdd from "components/TopAdd";
import RightAdd from "components/RightAdd";

import { getArticles } from "../services/article_service";
import { getOffers } from "../services/offer_service";
import { getEvent } from "../services/event_service";
import { getGames } from "../services/game_service";
import { getTopAdd, getRightAdd } from "../services/add_service";
import EventList from "components/EventList";
import { mapGameToEvent } from "../components/utils/GameToEvent";
import { getCurrentSeasonPlayerStatistics } from "../services/game_service";

import yellowCard from "img/yellow-card.svg";
import redCard from "img/red-card.svg";

import moment from "moment";

function Home() {
  const { t } = useTranslation();
  // Leaving it for future, we might add articles here
  const [articleLatestList, setArticleLatestList] = useState([]);
  const [countOfferCoach, setCountOfferCoach] = useState(0);
  const [countOfferPlayer, setCountOfferPlayer] = useState(0);
  const [countOfferOther, setCountOfferOther] = useState(0);
  const [nextEvents, setNextEvents] = useState([]);

  const [statsGoals, setStatsGoals] = useState(null);
  const [statsYellow, setStatsYellow] = useState(null);
  const [statsRed, setStatsRed] = useState(null);
  const [statsMinutes, setStatsMinutes] = useState(null);
  const [statsAssists, setStatsAssists] = useState(null);

  const [statsGamesWon, setStatsGamesWon] = useState(0);
  const [statsGamesDraw, setStatsGamesDraw] = useState(0);
  const [statsGamesLost, setStatsGamesLost] = useState(0);

  const [age, setAge] = useState(null);
  const [teamList] = useState(JSON.parse(localStorage.getItem("teamIDs")));
  const [position, setPosition] = useState(
    JSON.parse(localStorage.getItem("position"))
      ? JSON.parse(localStorage.getItem("position")).join(", ")
      : ""
  );

  const [articleLatestNum] = useState(config.Articles.Articles_Highlighted);

  useEffect(() => {
    async function getData() {
      let eventLists = await getEvent({
        when: {
          $between: [
            moment().format(config.STRAPI_DATETIME_FORMAT),
            moment().add("7", "d").format(config.STRAPI_DATETIME_FORMAT),
          ],
        },
      });
			await getTopAdd('&filters[position][$eq]=TOP')
			await getRightAdd('&filters[position][$eq]=RIGHT')
      let gamesFuture = await getGames({
        date: { $gte: moment().format(config.STRAPI_DATETIME_FORMAT) },
      });
      gamesFuture = gamesFuture.splice(0, 3);

      let offers = await getOffers();
      let countJogador = 0;
      let countTreinador = 0;
      let countOutros = 0;

      offers.forEach((el) => {
        if (el.attributes.role === "Jogador") {
          countJogador++;
        } else if (el.attributes.role === "Treinador") {
          countTreinador++;
        } else {
          countOutros++;
        }
      });

      setCountOfferCoach(countTreinador);
      setCountOfferOther(countOutros);
      setCountOfferPlayer(countJogador);

      if (localStorage.getItem("role") === "Treinador") {
        setPosition("Treinador Principal");

        let games = await getGames();
        let wonGames = 0;
        let drawGames = 0;
        let lostGames = 0;

        games.forEach((el) => {
          if (
            Number.isInteger(el.attributes.away_team_goals) &&
            Number.isInteger(el.attributes.home_team_goals)
          ) {
            if (el.attributes.location === "away") {
              if (
                el.attributes.away_team_goals > el.attributes.home_team_goals
              ) {
                wonGames++;
              }
              if (
                el.attributes.away_team_goals === el.attributes.home_team_goals
              ) {
                drawGames++;
              }
              if (
                el.attributes.away_team_goals < el.attributes.home_team_goals
              ) {
                lostGames++;
              }
            } else {
              if (
                el.attributes.away_team_goals > el.attributes.home_team_goals
              ) {
                lostGames++;
              }
              if (
                el.attributes.away_team_goals === el.attributes.home_team_goals
              ) {
                drawGames++;
              }
              if (
                el.attributes.away_team_goals < el.attributes.home_team_goals
              ) {
                wonGames++;
              }
            }
          }
        });

        setStatsGamesWon(wonGames);
        setStatsGamesDraw(drawGames);
        setStatsGamesLost(lostGames);
      }

      // Player Games Statistics
      if (localStorage.getItem("role") === "Jogador") {
        const statistics = await getCurrentSeasonPlayerStatistics(
          localStorage.getItem("accountId")
        );
      

        let yellow = 0;
        let red = 0;
        let minutes = 0;
        let goals = 0;
        let assists = 0;

        statistics.forEach((el) => {
          if (!el?.attributes?.players_status) {
            return;
          }

          const gameStats = el?.attributes?.players_status.find(
            (el) => el.id == localStorage.getItem("accountId")
          );

          if(!gameStats) return;

          yellow += +gameStats.yellowCards;
          red += +gameStats.redCards;
          minutes += +gameStats.playedMinutes;
          goals += +gameStats.goals;
          assists += +gameStats.assists;
        });

        setStatsGoals(goals);
        setStatsYellow(yellow);
        setStatsRed(red);
        setStatsMinutes(minutes);
        setStatsAssists(assists);
      }
      
      const age = moment().diff(
        localStorage.getItem("date_of_birth"),
        "years"
      );
      setAge(age);

      gamesFuture = mapGameToEvent(gamesFuture)
      eventLists = eventLists.concat(gamesFuture);

      eventLists = eventLists.sort(function (a, b) {
        return new Date(a.attributes.when) - new Date(b.attributes.when);
      });

      setNextEvents(eventLists);
    }

    getData();
  }, []);

  const renderArticles = async () => {
    const articleList = await getArticles();
    const articleLatestList = [];
    let articleRendered = 0;

    for (let article of articleList) {
      if (articleRendered < articleLatestNum) {
        articleLatestList.push(article);
      }

      articleRendered++;
    }
    return articleLatestList;
  };

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
         <TopAdd></TopAdd>
         <div style={{"display": "flex"}}>
          <section className="section dashboard">
            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <li className="is-active">Início</li>
              </ul>
            </nav>

            <div className="hero is-footsolution">
              <div className="columns">
                <div className="column">
                  <h1 className="title is-3">
                    Olá {localStorage.getItem("accountName")}
                  </h1>
                </div>
              </div>
            </div>

            <div className="columns credencial-style">
              <div
                style={{ padding: 0, margin: "15px" }}
                className="columns exist"
              >
                <div className="column">
                  {/* senão tiver os dados deve mostrar uma frase genérica para ir preencher os dados */}
                  {/* PERFIL DE JOGADOR. */}
                  <h2
                    style={{ marginBottom: 0, color: "#D2D0D0" }}
                    className="title is-5"
                  >
                    {localStorage.getItem("role") === "Clube"
                      ? "Clube"
                      : "Nome"}
                  </h2>
                  <span style={{ fontWeight: 900 }}>
                    {localStorage.getItem("accountName")}
                  </span>
                  <br />
                  <br />
                  <h2
                    style={{ marginBottom: 0, color: "#D2D0D0" }}
                    className="title is-5"
                  >
                    Email
                  </h2>
                  <span style={{ fontWeight: 900 }}>
                    {localStorage.getItem("username")}
                  </span>
                  <br />
                  <br />
                  <Link to={"/definicoes-conta"} className="button is-link">
                    Editar
                  </Link>
                </div>

                <div className="column">
                  <h2
                    style={{ marginBottom: 0, color: "#D2D0D0" }}
                    className="title is-5"
                  >
                    {localStorage.getItem("role") === "Clube"
                      ? "Ano de fundação"
                      : "Data de nascimento"}
                  </h2>

                  <span style={{ fontWeight: 900 }}>
                    {localStorage.getItem("role") === "Clube" &&
                    localStorage.getItem("foundation_year")
                      ? `${localStorage.getItem("foundation_year")}`
                      : ""}

                    {localStorage.getItem("role") !== "Clube" &&
                    localStorage.getItem("date_of_birth")
                      ? `${localStorage.getItem("date_of_birth")} (${age} anos)`
                      : ""}
                  </span>
                  <br />
                  <br />

                  <h2
                    style={{ marginBottom: 0, color: "#D2D0D0" }}
                    className="title is-5"
                  >
                    {localStorage.getItem("role") === "Clube"
                      ? "Localidade"
                      : "Clube"}
                  </h2>
                  <span style={{ fontWeight: 900 }}>
                    {localStorage.getItem("role") === "Clube"
                      ? localStorage.getItem("locality")
                      : teamList.length > 0
                      ? teamList[0].label
                      : ""}
                  </span>
                  <br />
                  <br />
                </div>

                <div className="column">
                  <h2
                    style={{ marginBottom: 0, color: "#D2D0D0" }}
                    className="title is-5"
                  >
                    {localStorage.getItem("role") === "Jogador"
                      ? "Posição"
                      : localStorage.getItem("role") === "Clube"
                      ? "Estádio"
                      : "Função"}
                  </h2>
                  <span style={{ fontWeight: 900 }}>
                    {localStorage.getItem("role") === "Clube"
                      ? localStorage.getItem("stadium")
                      : position}
                  </span>
                  <br />
                  <br />

                  {localStorage.getItem("role") !== "Clube" && (
                    <>
                      <h2
                        style={{ marginBottom: 0, color: "#D2D0D0" }}
                        className="title is-5"
                      >
                        Escalão
                      </h2>
                      <span style={{ fontWeight: 900 }}>
                        {teamList.length > 0 ? teamList[0].division : ""}
                      </span>
                      <br />
                      <br />
                    </>
                  )}
                </div>

                {localStorage.getItem("role") === "Jogador" && (
                  <div className="column">
                    <h2 className="title is-5">Estatísticas desta época:</h2>
                    <p>
                      <h3 style={{ marginBottom: 0, color: "#D2D0D0" }}>
                        {" "}
                        Minutos Jogados {statsMinutes}
                      </h3>
                      <h3 style={{ marginBottom: 0, color: "#D2D0D0" }}>
                        {" "}
                        Golo(s) {statsGoals}
                      </h3>
                      <h3 style={{ marginBottom: 0, color: "#D2D0D0" }}>
                        {" "}
                        Assistência(s) {statsAssists}
                      </h3>
                      <br />

                      <h3 style={{ marginBottom: 0, color: "#D2D0D0" }}>
                        {" "}
                        Cartões <br />
                        <img src={yellowCard} alt="" /> {statsYellow}
                        <br />
                        <img src={redCard} alt="" /> {statsRed}
                      </h3>
                    </p>
                  </div>
                )}

                {localStorage.getItem("role") === "Treinador" && (
                  <div
                    className="column"
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      flexDirection: "row",
                    }}
                  >
                    <div>
                      <span style={{ marginBottom: 0, color: "#D2D0D0" }}>
                        V
                      </span>
                      <br></br>
                      <span className="bold">{statsGamesWon}</span>
                    </div>
                    <div>
                      <span style={{ marginBottom: 0, color: "#D2D0D0" }}>
                        E
                      </span>
                      <br></br>
                      <span className="bold">{statsGamesDraw}</span>
                    </div>
                    <div>
                      <span style={{ marginBottom: 0, color: "#D2D0D0" }}>
                        D
                      </span>
                      <br></br>
                      <span className="bold">{statsGamesLost}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="columns credencial-style">
              <div className="column exist">
                <h2 className="title is-5">Calendário:</h2>
                <br />
                <EventList events={nextEvents}></EventList>
              </div>
            </div>

            <div className="columns credencial-style">
              <div className="column exist">
                <h2 className="title is-5">Mercado</h2>
                <br />
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <Link to={"/ofertas"} className="vacancy">
                    <p className="vacancy-header-header">{countOfferPlayer}</p>
                    <p className="vacancy-header-text">vagas jogador</p>
                  </Link>
                  <Link to={"/ofertas"} className="vacancy">
                    <p className="vacancy-header-header">{countOfferCoach}</p>
                    <p className="vacancy-header-text">vagas treinador</p>
                  </Link>
                  <Link to={"/ofertas"} className="vacancy">
                    <p className="vacancy-header-header">{countOfferOther}</p>
                    <p className="vacancy-header-text">
                      vagas outros profissionais
                    </p>
                  </Link>
                </div>
              </div>
            </div>

            <div className="columns credencial-style">
              <div className="column exist">
                <h2 className="title is-5">{t("last_articles")}</h2>
                {articleLatestList.map((el, idx) => (
                  <div key={idx} className="content">
                    <h3 className="subtitle is-6">{el.attributes.title}</h3>
                    <p>
                      {el.attributes.content.substring(0, 150).length > 145
                        ? el.attributes.content.substring(0, 150) + "..."
                        : el.attributes.content.substring(0, 150)}
                    </p>
                  </div>
                ))}

                <Link className="button is-link btn1" to="/artigos">
                  {t("see_articles")}
                </Link>
              </div>
            </div>
          </section>
         <RightAdd></RightAdd>
         </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
